import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, Ionproduct, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonCheckbox } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';


export function Modal_StockProduct_InStore(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [productID, setProductID] = useState(null);

    let [searchResults, setSearchResults] = useState([]);

    let productProductNameRef = useRef('');
    let productNameRef = useRef('');


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
       // setSearchResults([]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '33_searchStockProduct',
                user: acctID,
                xSearchData: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_productId: cols[0],
                                        db_productName: cols[1],
                                        db_productDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorPhoneNumber: cols[4],
                                        db_vendorAddress: cols[5],
                                        db_vendorCity: cols[6],
                                        db_vendorCountry: cols[7],
                                        db_costPerUnit: cols[8],
                                        dv_salePrice: cols[9],
                                        db_pic1: cols[10],
                                        db_pic2: cols[11],
                                        db_pic3: cols[12],
                                        db_pic4: cols[13],
                                        db_attachement: cols[14],
                                        db_createdBy: cols[15],
                                        db_isActivated: cols[16],
                                        db_storefront: cols[17],
                                        db_qtyAvailable: cols[18]

                                    })
                                });
                                document.getElementById('stockProduct_inStore_div').style.display = 'inline-block';

                            }

                    })
        }


    function replenishStock_product_onSite()
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '33_restock_inStoreProduct',
                user: acctID,
                xInventoryProductID: productID,
                xInventoryReplenishStock: quantityReplenishedStock,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            setProductID(null);
            setQuantityReplenishedStock(null);
            handleInput(['stocked_product', ""]);
        })
        .catch(error => {
            console.error(error);
        })

       // setStockInventoryProductModal_onSite(false);
    }


    let timeout;

    function handleInput(event) {

        setSearchResults([]);

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchList(event), 2000); // Set a new timeout
    
    }
    
    
function handleQuantityReplenish(e) {

    setQuantityReplenishedStock(e.target.value);

}

function setProductIDHandler(event) {

    if (productID === event) {
        // Deselect if the same item is clicked
        setProductID(null);
    } else {
        // Select the new item
        setProductID(event);
    }
};



useEffect(() => {

    searchList(['initial_search', ""]);

}, [])

//alert('In ONSITE PRODUCT _ Inventory');
//alert(authenticatedMerchent_context.selectedTutorial?.tutorial_id);
//alert(authenticatedMerchent_context.selectedTutorial?.details?.step_1);
//alert(authenticatedMerchent_context.device);

        return (
            <React.Fragment>
        {props.openModal == true ?
        (
                <IonModal id='stockInventoryProductModal_onSite' isOpen={ props.openModal}>
                <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>RESTOCK PRODUCT - IN-STORE</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content'>

                    <IonGrid >
                        <IonRow>
                        <IonCol>
                                <label for='searchInventoryProduct_StockProduct'>Search Inventory Product - InStore:</label>
                                <input type='text' id='searchInventoryProduct_StockProduct' ref={ productNameRef } placeholder='Search Inventory products To Stock' onInput={() => handleInput(['stock_product_inStore', productNameRef.current.value])} list='searchInventoryProduct_StockProductList' autocomplete='off' required></input>
                                <datalist id='searchInventoryProduct_StockProductList'>
                                    {searchResults.map((result) => (
                                        <option key={result.db_productId} value={result.db_productName}></option>
                                    ))}
                                </datalist>
                            </IonCol>
                        </IonRow>
                        </IonGrid>
                        <div id='stockProduct_inStore_div' style={{display: 'none'}}>
                            <IonGrid >
                                    <IonRow >
                                            {/*<IonCol >product ID</IonCol>*/}
                                            <IonCol size='5'>product Name</IonCol>
                                            <IonCol size='2'>Qty InStock</IonCol>
                                            <IonCol size='2'>Activated?</IonCol>
                                            <IonCol size='3'>Action</IonCol>
                                    </IonRow>
                                    {searchResults.map((detailData) =>   {
                                        return (
                                            <IonRow class='gridResultBody'>
                                                {/*<IonCol >{detailData.db_productId}</IonCol>*/}
                                                <IonCol size='5'>{detailData.db_productName}</IonCol>
                                                <IonCol size='2'>{detailData.db_qtyAvailable}</IonCol>
                                                <IonCol size='2'>{detailData.db_isActivated}</IonCol>
                                                <IonCol size='3'>
                                                    <IonCheckbox checked={productID == detailData.db_productId} disabled={productID != null && productID != detailData.db_productId} placeholder='Enter Qty' onIonChange={() => setProductIDHandler(detailData.db_productId)}></IonCheckbox>           
                                                </IonCol>
                                            </IonRow>
                                        )
                                    }
                                    )}
                                    {productID != null && <IonRow>
                                        <IonCol size='12'>
                                            <IonLabel>Quantity To Add</IonLabel>
                                        </IonCol>
                                    </IonRow>}
                                    {productID != null &&<IonRow>
                                        <IonCol size='12'>
                                            <IonInput className='professional-input' type='number' placeholder="Enter Qty to Add" onIonChange={(e) => setQuantityReplenishedStock(e.target.value)}></IonInput>
                                        </IonCol>
                                    </IonRow>}
                                     {productID != null &&<IonRow>
                                        <IonCol size='12'>
                                            <IonButton onClick={() => replenishStock_product_onSite()}> Confirm Replenish </IonButton> 
                                        </IonCol>
                                    </IonRow>}
                                </IonGrid>
                        </div>
                </IonContent>
                <IonFooter className='appFooter'>
                    <IonGrid>
                            <IonRow>
                                <IonCol size="12">
                                    <IonButton className='modal_footer_button_right' onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                </IonFooter>
                </IonModal>
        ) : null}

            </React.Fragment>
        )
    }   